// Utility: walks a React element tree and returns the plain text content.
// Used to feed JSON-LD FAQ schema from the same source-of-truth FAQ data
// that renders rich UI (links, lists, <strong>) — no duplication of copy.
import React from 'react';

export function extractText(node) {
  if (node == null || typeof node === 'boolean') return '';
  if (typeof node === 'string' || typeof node === 'number') return String(node);
  if (Array.isArray(node)) return node.map(extractText).join(' ');
  if (React.isValidElement(node)) return extractText(node.props.children);
  return '';
}

// Normalize whitespace so the resulting plain text reads cleanly in
// schema.org consumers and Google's rich result test.
export function toPlainText(node) {
  return extractText(node)
    .replace(/\s+/g, ' ')
    .replace(/\s([.,;:!?])/g, '$1')
    .trim();
}
